import translate from "@insite/client-framework/Translate"

export function GetChangeCustomerMenuTitle(billToCount: number){
    return billToCount > 1 ? translate("Change Account, Ship-To & Branch") : translate("Change Ship-To & Branch");
}
